export default {
  setupDate: { id: 'apply' },
  days_3: { id: 'label_days_3' },
  week_1: { id: 'label_week_1' },
  weeks_2: { id: 'label_weeks_2' },
  month_1: { id: 'label_months_1' },
  customDate: { id: 'custom' },
}
